const $ = jQuery;
const getViewportGeometry = () => {
    const geometry = {
        width: $(window).width(),
        height: $(window).height(),
        documentWidth: $(document).width(),
        documentHeight: $(document).height(),
        scrollTop: $(window).scrollTop(),
    };

    geometry.scrollTopMiddle = geometry.scrollTop + geometry.height * 0.5;

    geometry.scrollTopFistQuarter = geometry.scrollTop + geometry.height * 0.25;
    geometry.scrollTopLastQuarter = geometry.scrollTop + geometry.height * 0.75;

    geometry.scrollBottom = geometry.scrollTop + geometry.height;

    return geometry;
}

export {getViewportGeometry}